var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 3C3.55964 3 3 3.55964 3 4.25V9.75C3 10.4404 3.55964 11 4.25 11H9.75C10.4404 11 11 10.4404 11 9.75V4.25C11 3.55964 10.4404 3 9.75 3H4.25ZM4.83333 4.5C4.64924 4.5 4.5 4.64924 4.5 4.83333V9.16667C4.5 9.35076 4.64924 9.5 4.83333 9.5H9.16667C9.35076 9.5 9.5 9.35076 9.5 9.16667V4.83333C9.5 4.64924 9.35076 4.5 9.16667 4.5H4.83333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 13C3.55964 13 3 13.5596 3 14.25V19.75C3 20.4404 3.55964 21 4.25 21H9.75C10.4404 21 11 20.4404 11 19.75V14.25C11 13.5596 10.4404 13 9.75 13H4.25ZM4.83333 14.5C4.64924 14.5 4.5 14.6492 4.5 14.8333V19.1667C4.5 19.3508 4.64924 19.5 4.83333 19.5H9.16667C9.35076 19.5 9.5 19.3508 9.5 19.1667V14.8333C9.5 14.6492 9.35076 14.5 9.16667 14.5H4.83333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 3C13.5596 3 13 3.55964 13 4.25V9.75C13 10.4404 13.5596 11 14.25 11H19.75C20.4404 11 21 10.4404 21 9.75V4.25C21 3.55964 20.4404 3 19.75 3H14.25ZM14.8333 4.5C14.6492 4.5 14.5 4.64924 14.5 4.83333V9.16667C14.5 9.35076 14.6492 9.5 14.8333 9.5H19.1667C19.3508 9.5 19.5 9.35076 19.5 9.16667V4.83333C19.5 4.64924 19.3508 4.5 19.1667 4.5H14.8333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 13C13.5596 13 13 13.5596 13 14.25V19.75C13 20.4404 13.5596 21 14.25 21H19.75C20.4404 21 21 20.4404 21 19.75V14.25C21 13.5596 20.4404 13 19.75 13H14.25ZM14.8333 14.5C14.6492 14.5 14.5 14.6492 14.5 14.8333V19.1667C14.5 19.3508 14.6492 19.5 14.8333 19.5H19.1667C19.3508 19.5 19.5 19.3508 19.5 19.1667V14.8333C19.5 14.6492 19.3508 14.5 19.1667 14.5H14.8333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.57097a56.svg";
export { ForwardRef as ReactComponent };